export default __webpack_public_path__ + "images/8bdc74641a58d6358427002cdb380258.svg";